import { render, staticRenderFns } from "./SelectDropdown_axa.vue?vue&type=template&id=49dbc672"
import script from "./SelectDropdown_axa.vue?vue&type=script&lang=js"
export * from "./SelectDropdown_axa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports